// Helper utility functions

/**
 * Get today's date as a string in YYYY-MM-DD format
 */
export const getTodayDateString = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Mystical message for unavailable content
 */
export const MYSTICAL_MESSAGE_UNAVAILABLE = "The echoes of this specific wisdom have settled, seeker. What was not unveiled in its original dawn remains veiled in the mists of past moments.";

/**
 * Delay helper for animations
 */
export const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Clamp a number between min and max
 */
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
